package horcrux.frontend.common

import react.useEffect

class LazyValFromEffect<A>(effect: () -> A) {
    private var _valueMaybe: A? = null
    init {
        useEffect {
            _valueMaybe = effect()
        }
    }

    val valueMaybe: A?
        get() = _valueMaybe
}
